module.exports = __webpack_public_path__ + "static/img/share.b436b40c.png";